


















import { Component, Mixins } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'
import TcwPopupTag from '@/components/common/TcwPopupTag.vue'

@Component({
  components: { TcwPopupTag }
})
export default class KintaiLockTag extends Mixins(BaseComponent) {}
